import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../components/homepage/HomePage'
import SupplierList from "@/components/suppliers/SupplierList";
import ProductList from "@/components/software/ProductList";
import StatusDashboard from "@/components/StatusDashboard"
import Invoices from "@/components/InvoiceAndPurchaseOrders/Invoices";
import PurchaseOrders from "@/components/InvoiceAndPurchaseOrders/PurchaseOrders";
import POBasedPayment from "@/components/Payments/POBasedPayment/POBasedPayment";
import SupplierDashboard from "@/components/SupplierDashboard";
import OneIntakeForm from "@/components/OneIntakeForm/OneIntakeForm"
import CONSTANTS from "@/store/constants";
import NonPOBasedPayment from "@/components/Payments/NonPOBasedPayment/NonPOBasedPayment";
import OneTimeSupplierPayment from "@/components/Payments/OneTimeSupplierPayment/OneTimeSupplierPayment";
import AdvancePOBasedPayment from "@/components/Payments/AdvancePOBasedPayment/AdvancePOBasedPayment";
import ShowSubmitPaymentModal from "@/components/Payments/ShowSubmitPaymentModal";
import InvoiceSubmission from "@/components/Payments/InvoiceSubmission/InvoiceSubmission";
import PODetailModalContainer from "@/components/InvoiceAndPurchaseOrders/PODetailModalContainer";
import InvoiceDetailModalContainer from "@/components/InvoiceAndPurchaseOrders/InvoiceDetailModalContainer";
import SCWalkThroughModalContainer from "../components/homepage/SCWalkThroughModalContainer";
import AgentRITMStatusContainer from "@/components/AgentRITMStatusContainer";
import QuestionnairePreviewContainer from "@/components/QuestionnairePreviewContainer";
import ExceptionSubmissionRequestForm from "@/components/ExceptionSubmissionRequest/ExceptionSubmissionRequestForm"

Vue.use(VueRouter);

export default new VueRouter({
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior:"smooth"
      }
    }else{

      return { x: 0, y: 0 };
    }
    
  },
  mode: 'history',
  base: '/apps/supplier-central',
  routes: [
    {
      path: "/",
      component: SupplierDashboard,
      redirect: `/${CONSTANTS.GUIDES_ALIAS}`,
      children: [
        {
          path: `/${CONSTANTS.GUIDES_ALIAS}`,
          component: HomePage,
          name: "HomePage",
          meta: {
            tab: "HomePage",
            navTabName: "Home",
            navTabOrder: 1
          }
        },
        {
          path: `/${CONSTANTS.GUIDES_ALIAS}/branches/:id`,
          component: HomePage,
          name: "branches",
          meta: {
            tab: "HomePage"
          }
        },
        {
          path: "/supplier-list",
          redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
          component: SupplierList,
          name: "SupplierList",
          meta: {
            tab: "SupplierList"
          }
        },
        {
          path: "/product-list",
          redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
          component: ProductList,
          name: "ProductList",
          meta: {
            tab: "ProductList",
            navTabName: "Software",
            navTabOrder: 2
          }
        },
        {
          path: "/status-dashboard",
          component: StatusDashboard,
          redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":"/status-dashboard/all-requests",
          //redirect: "/status-dashboard/all-requests",
          name: "StatusDashboard",
          meta: {
            tab : "StatusDashboard",
            navTabName: "My supplier requests",
            navTabOrder: 3
          }
        },
        {
          path: "/status-dashboard/status/:ritm",
          component: AgentRITMStatusContainer,
          name: "RITMStatus",
          meta: {
            tab : "RITMStatus",
          }
        },
        {
          path: "/status-dashboard/questionnaire/:ritm",
          component: QuestionnairePreviewContainer,
          name: "QuestionnairePreviewContainer",
          meta: {
            tab : "QuestionnairePreviewContainer",
          }
        },
        {
          path: "/status-dashboard/:supplierRequestCategory",
          component: StatusDashboard,
          name: "SupplierRequestCategory",
          meta: {
            tab : "StatusDashboard"
          }
        },
        {
          path: "/invoice-dashboard/:invoiceCategory",
          component: Invoices,
          name: "InvoiceCategory",
          meta: {
            tab : "Invoices",
            showSubmitPaymentBtn:true,
            showAPAdminViewBtn: true,
          }
        },
        {
          path: "/invoices",
          redirect: "/invoice-dashboard/all-invoices"
        },
        {
          path: '/invoice-dashboard',
          component: Invoices,
          redirect:CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":"/invoice-dashboard/all-invoices",
          //redirect: "/invoice-dashboard/all-invoices",
          name: "Invoices",
          meta: {
            showSubmitPaymentBtn:true,
            showAPAdminViewBtn: true,
            tab: "Invoices",
            navTabName: "My invoices",
            navTabOrder: 5
          }
        },
        {
          path: "/purchase-orders",
          redirect:CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
          component: PurchaseOrders,
          name: "PurchaseOrders",
          meta: {
            showSubmitPaymentBtn:true,
            showAPAdminViewBtn : true,
            tab: "PurchaseOrders",
            navTabName: "My purchase orders",
            navTabOrder: 4
          }
        },
        {
          path: "/purchase-order-detail/:key/:value",
          component: PODetailModalContainer,
          name: "Filtered POs",
          meta: {
            showSubmitPaymentBtn:false,
            showAPAdminViewBtn : false,
            tab: "Filtered POs"
          }
        },
        {
          path: "/invoice-detail/:invoiceNumber/:invoiceValue/:docId/:docIdValue",
          component: InvoiceDetailModalContainer,
          name: "Filtered Invoices",
          meta: {
            showSubmitPaymentBtn:false,
            showAPAdminViewBtn :false,
            tab: "Filtered Invoices"
          }
        }

      ]
    },
    {
      path: "/one-intake-form",
      redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
      component: OneIntakeForm,
      name: "OneIntakeForm",
      meta: {
        tab: "OneIntakeForm",
        feedbackTitle: "Supplier Onboarding Experience"
      }
    },
    {
      path: "/one-intake-form/draft/:id",
      redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
      component: OneIntakeForm,
      name: "DraftIntakeForm",
      meta: {
        tab: "DraftIntakeForm",
        feedbackTitle: "Supplier Onboarding Experience"
      }
    },
    {
      path: "/one-intake-form/duplicate-case/:id",
      redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
      component: OneIntakeForm,
      name: "DuplicateIntakeForm",
      meta: {
        tab: "DuplicateIntakeForm"
      }
    },
    {
      path: "/one-intake-form/returned-request/:id",
      redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
      component: OneIntakeForm,
      name: "ReturnedRequestIntakeForm",
      meta: {
        tab: "ReturnedRequestsForm"
      }
    },
    {
      path: "/po-based-payment",
      component: POBasedPayment,
      name: "POBasedPayment",
      meta: {
        tab: "POBasedPayment",
      }
    },
    {
      path: "/po-based-payment/draft/:id",
      component: POBasedPayment,
      name: "DraftPOBasedPaymentForm",
      meta: {
        tab: "DraftPOBasedPaymentForm",
      }
    },
    {
      path: "/po-based-payment/copy/:docId",
      component: POBasedPayment,
      name: "CopyPOBasedPaymentForm",
      meta: {
        tab: "CopyPOBasedPaymentForm",
      }
    },
    {
      path: "/non-po-based-payment",
      component: NonPOBasedPayment,
      name: "NonPOBasedPayment",
      meta: {
        tab: "NonPOBasedPayment"
      }
    },
    {
      path: "/non-po-based-payment/draft/:id",
      component: NonPOBasedPayment,
      name: "DraftNonPOBasedPaymentForm",
      meta: {
        tab: "DraftNonPOBasedPaymentForm",
      }
    },
    {
      path: "/non-po-based-payment/copy/:docId",
      component: NonPOBasedPayment,
      name: "CopyNonPOBasedPaymentForm",
      meta: {
        tab: "CopyNonPOBasedPaymentForm",
      }
    },
    {
      path: "/one-time-supplier-payment",
      component: OneTimeSupplierPayment,
      name: "OneTimeSupplierPayment",
      meta: {
        tab: "OneTimeSupplierPayment"
      }
    },
    {
      path: "/one-time-supplier-payment/draft/:id",
      component: OneTimeSupplierPayment,
      name: "DraftOneTimeSupplierPayment",
      meta: {
        tab: "DraftOneTimeSupplierPayment"
      }
    },
    {
      path: "/adv-po-based-payment",
      component: AdvancePOBasedPayment,
      name: "AdvancePOBasedPayment",
      meta: {
        tab: "AdvancePOBasedPayment"
      }
    },
    {
      path: "/invoice-submission",
      component: InvoiceSubmission,
      name: "InvoiceSubmission",
      meta: {
        tab: "InvoiceSubmission"
      }
    },
    {
      path: "/exception-submission",
      redirect: CONSTANTS.IS_SUPPLIER_CENTRAL_DOWN?"/supplier-guide":false,
      component: ExceptionSubmissionRequestForm,
      name: "ExceptionSubmissionRequest",
      meta: {
        tab: "ExceptionSubmissionRequest"
      }
    },
    {
      path: "/payment-types",
      component: ShowSubmitPaymentModal,
      name: "ShowSubmitPaymentModal",
      meta: {
        tab: "ShowSubmitPaymentModal",
        showSubmitPaymentBtn:false,
        showAPAdminViewBtn :false,
      }
    },
    {
      path: "/working-with-supplier",
      component: SCWalkThroughModalContainer,
      name: "SCWalkThroughModalContainer",
      meta: {
        tab: "SCWalkThroughModalContainer",
      }
    },
    {
      path: "/forbidden",
      name: 'Forbidden',
      beforeEnter() {
        const redirectUrl = CONSTANTS.EH_URL + '/forbidden'
        window.location.replace(redirectUrl)
      }
    },
    {
      path: "*",
      name: '404',
      beforeEnter(to) {
        if(!to.path.includes('/callback')) {
          const notFoundURL = CONSTANTS.EH_URL + '/404'
          window.location.replace(notFoundURL)
        }
      }
    }

  ]
})
